import { useState } from 'react'
import { MdAdd, MdPerson } from 'react-icons/md'
import { FlightAttendantCard } from '../../components/cards'
import { Button, LoadingSpinner, EmptyState, Pagination } from '../../components/ui'
import { useFlightAttendant } from '../../hooks/useFlightAttendant'

function FlightAttendantList({
  flightAttendants = [],
  onViewFlightAttendant,
  onEditFlightAttendant,
  onDeleteFlightAttendant,
}) {
  const [isLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage] = useState(12) // Show 12 flight attendants per page (4 rows of 3 in grid)

  const { deleteFlightAttendantAsync } = useFlightAttendant()

  const handleDeleteFlightAttendant = async (flightAttendant) => {
    try {
      await deleteFlightAttendantAsync(flightAttendant._id)
      if (onDeleteFlightAttendant) {
        onDeleteFlightAttendant(flightAttendant)
      }
    } catch (error) {
      console.error('Error deleting flight attendant:', error)
    }
  }

  const handleViewFlightAttendant = (flightAttendant) => {
    if (onViewFlightAttendant) {
      onViewFlightAttendant(flightAttendant)
    }
  }

  const handleEditFlightAttendant = (flightAttendant) => {
    if (onEditFlightAttendant) {
      onEditFlightAttendant(flightAttendant)
    }
  }

  // Pagination logic
  const totalPages = Math.ceil(flightAttendants.length / itemsPerPage)
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage
  const paginatedFlightAttendants = flightAttendants.slice(startIndex, endIndex)

  const handlePageChange = (page) => {
    setCurrentPage(page)
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  return (
    <div className="space-y-6">
      {/* Flight Attendant Grid */}
      {flightAttendants.length === 0 ? (
        <EmptyState
          icon={<MdPerson className="text-4xl text-neutral-400" />}
          title="No flight attendants found"
          description="Get started by adding your first flight attendant"
          action={
            <Button
              variant="primary"
              onClick={() => {
                /* TODO: Implement create flight attendant */
              }}
              className="flex items-center space-x-2"
            >
              <MdAdd className="text-lg" />
              <span>Add Flight Attendant</span>
            </Button>
          }
        />
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {paginatedFlightAttendants.map((flightAttendant) => (
              <FlightAttendantCard
                key={flightAttendant._id}
                flightAttendant={flightAttendant}
                onView={() => handleViewFlightAttendant(flightAttendant)}
                onEdit={() => handleEditFlightAttendant(flightAttendant)}
                onDelete={() => handleDeleteFlightAttendant(flightAttendant)}
              />
            ))}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="pt-4 border-t border-neutral-200 dark:border-neutral-700">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                itemsPerPage={itemsPerPage}
                totalItems={flightAttendants.length}
              />
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default FlightAttendantList
